import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchMentorById } from '../../services/mentorService';
import Layout from '../layout/Layout';
import './MentorDetail.css';

const MentorDetail = () => {
  const [mentor, setMentor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getMentorDetails = async () => {
      try {
        const mentorData = await fetchMentorById(id);
        setMentor(mentorData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching mentor details:', err);
        setError('OG情報の取得に失敗しました。');
        setLoading(false);
      }
    };

    getMentorDetails();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) return <div className="loading">読み込み中...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!mentor) return <div className="error">OGが見つかりません。</div>;

  return (
    <Layout>
        <div id="mentor-detail">
          <div className="profile-header">
            <img 
              className="mentor-icon" 
              src={mentor.アイコンURL || "/images/mentor_icon.png"} 
              alt="OGのアイコン" 
            />
            <h1 className="mentor-name">{mentor.氏名}</h1>
          </div>
          <table>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "75%" }} />
            </colgroup>
            <tbody>
              <tr><th colSpan={2} id="section">プロフィール</th></tr>
              <tr><th>氏名</th><td className="mentor-name-table">{mentor.氏名}</td></tr>
              <tr><th>出身大学</th><td className="university">{mentor.出身大学}</td></tr>
              <tr><th>卒業年</th><td className="graduate">{mentor.卒業した年}</td></tr>
              <tr><th>連絡先</th><td className="contact">{mentor.連絡先}</td></tr>
              <tr><th colSpan={2} id="section">就職先情報</th></tr>
              <tr><th>業界</th><td className="industry">{mentor.就職先業界}</td></tr>
              <tr><th>会社名</th><td className="company">{mentor.会社名}</td></tr>
              <tr><th colSpan={2} id="section">学生の皆さんへ</th></tr>
              <tr><th>一言メッセージ</th><td className="message">{mentor.一言メッセージ}</td></tr>
            </tbody>
          </table>
        </div>
        <button id="backButton" onClick={handleBack}>OG一覧へ戻る</button>
    </Layout>
  );
};

export default MentorDetail; 